export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_LOADING = "SET_LOADING";
export const SET_USERDETAILS = "SET_USERDETAILS";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_OTP_TIME = "SET_OTP_TIME";
export const SET_EMAIl_VERIFIED = "SET_EMAIl_VERIFIED";
export const SET_DARK_MODE = "SET_DARK_MODE";






